module.exports = __webpack_public_path__ + "img/file-x-fill.78da7494.svg";